import { render, staticRenderFns } from "./MeasureTab.vue?vue&type=template&id=aed08fc2&scoped=true"
import script from "./MeasureTab.vue?vue&type=script&lang=js"
export * from "./MeasureTab.vue?vue&type=script&lang=js"
import style0 from "./MeasureTab.vue?vue&type=style&index=0&id=aed08fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed08fc2",
  null
  
)

export default component.exports